import { SUBMIT_LOGIN, DELETE_LOGIN, LOGIN_ERROR, SUBMIT_SIGNUP } from './actionTypes';
import _ from 'lodash';
import axios from 'axios';
axios.defaults.baseURL = `${process.env.REACT_APP_BE_URL}/api`;
axios.defaults.withCredentials = true;

const saveLogin = user => ({
  type: SUBMIT_LOGIN,
  payload: {
    ...user
  }
});

const deleteLogin = () => ({
  type: DELETE_LOGIN,
  payload: {}
});

const loginError = err => ({
  type: LOGIN_ERROR,
  payload: {
    ...err
  }
});

const saveSignUp = (user) => ({
  type: SUBMIT_SIGNUP,
  payload: {
    ...user
  }

});

export const submitLogin = ({ email, password }) => {
  return async ( dispatch ) => {
    try {
      const response = await axios.post( `/login`, { email, password } );
			const user = _.get( response, 'data.user' );

      if( !_.isNil(user) ) {
        return dispatch( saveLogin( user ) );
      } else {
        return dispatch( loginError({ status: 401, statusText: 'Invalid email or password.' }) );
      }
    } catch(err) {
      console.error(err);
      return dispatch( loginError( err.response ) );
    }

  }
}

export const submitSignUp = ({ first_name, last_name, email, phone, role_id }) => {
  return async ( dispatch ) => {
    try {
      console.log(first_name, last_name, email, phone, role_id)
      const response = await axios.post(`/register`, {
        first_name,
        last_name,
        email,
        phone,
        role_id
      })

      console.log('response: ', response)
      const user = _.get (response, 'data.user')
      if( !_.isNil(user) ) {
        return dispatch( saveSignUp( user ) );
      }  else {
        return dispatch( loginError({ status: 401, statusText: 'Invalid email or password.' }) );
      }
    } catch(error) {
      console.error(error)
      return dispatch(loginError(error.response))
    }
  }
}

export const forgotPassword = (password, confirmPassword) => {
  return async ( dispatch ) => {
    try {
      const response = await axios.post( '/forgot-password' );
			const user = _.get( response, 'data.user' );

      if( !_.isNil(user) ) {
        return dispatch( saveLogin( user ) );
      } else {
        return dispatch( loginError({ status: 403, statusText: 'You could not be authenticated.' }) );
      }
    } catch(err) {
      console.error(err);
      return dispatch( loginError( err.response ) );
    }
  }
}


export const submitLogout = () => {
  return async ( dispatch ) => {
    try {
      await axios.get( `/logout` );
      return dispatch( deleteLogin() );
    } catch( err ) {
      console.error(err);
      return dispatch( loginError( err.response ) );
    }
  }
}

export const getLocalUser = () => {
  return async ( dispatch ) => {
    try {
      const response = await axios.get( '/user/auth-check' );
			const user = _.get( response, 'data.user' );

      if( !_.isNil(user) ) {
        return dispatch( saveLogin( user ) );
      } else {
        return dispatch( loginError({ status: 403, statusText: 'You could not be authenticated.' }) );
      }
    } catch(err) {
      console.error(err);
      return dispatch( loginError( err.response ) );
    }
  }
}
